import Vue from 'vue';
import i18n from "@/plugins/vueI18n";

export const fileSizeToMB = (size: number) => {
  if(size) {
    return size / (1024 * 1024);
  }

  return null;
}

export const validFileSize10MB = (size: number) => {
  if(size && size > 10) {
    const message: string = i18n.messages[i18n.locale]['GeneralTranslations.ImageMustBeUnder10MegabytesErrorMessage'].toString();

    Vue.$toast.open({
      message: message,
      type: "error"
    });

    return false;
  }

  return true;
}

export const validVideoSize10MB = (size: number) => {
  if(size && size > 10) {
    const message: string = i18n.messages[i18n.locale]['GeneralTranslations.VideoMustBeUnder10MegabytesErrorMessage'].toString();

    Vue.$toast.open({
      message: message,
      type: "error"
    });

    return false;
  }

  return true;
}

export const validVideoSize130MB = (size: number) => {
  if(size && size > 130) {
    const message: string = i18n.messages[i18n.locale]['GeneralTranslations.VideoMustBeUnder130MegabytesErrorMessage'].toString();

    Vue.$toast.open({
      message: message,
      type: "error"
    });

    return false;
  }

  return true;
}

export const validVideoDuration10Sec = (file): Promise<boolean> => {
  return new Promise<boolean>((resolve) => {
    const videoUrl = URL.createObjectURL(file);
    const videoElement = document.createElement('video');
    videoElement.preload = 'metadata';
    videoElement.src = videoUrl;

    videoElement.onloadedmetadata = () => {
      URL.revokeObjectURL(videoUrl);
      const duration = videoElement.duration;

      if (duration > 10) {
        const message = i18n.messages[i18n.locale]['GeneralTranslations.Video10SecondsValidationMessage'].toString();

        Vue.$toast.open({
          message: message,
          type: 'error'
        });

        resolve(false);
      } else {
        resolve(true);
      }
    };

    videoElement.onerror = () => {
      URL.revokeObjectURL(videoUrl);
      Vue.$toast.open({
        message: 'Invalid video file',
        type: 'error'
      });
      resolve(false);
    };
  });
};

